import useLanguage from '@snowit/system/useLanguage';
import { MessageIllustration } from '@snowit/ui';

import s from './NotFound.module.scss';

const NotFound = () => {
  const { t } = useLanguage();
  return (
    <div className={s.illustration}>
      <MessageIllustration
        className={'mb-xl'}
        image={'img_snowman_error'}
        title={t('lzy.message.page_not_found.title')}
        text={t('lzy.message.page_not_found.text')}
      />
    </div>
  );
};

export default NotFound;
